// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { typeof History } from 'react-router-dom';
import * as sidePanelActionCreators from 'esm-web-pro/redux/side-panel/actions';
import { ApiFormWithModel } from 'esm-web-pro/containers/forms/FormWithModel';
import type { DataPort } from './DataPort';


type Props = {
    id: string,
    point: DataPort,
    onClose: Function,
    onSave: Function,
    mapUuid: string,
    history: History,
    match: Object,
    setSensitivity: (key: string, sensitivity: boolean) => void,
};

const DataPortEditor = (props: Props) => {
    const {
        point, mapUuid, onClose, onSave, history, match, id, setSensitivity,
    } = props;

    const handleUpdate = (response: Object) => {
        const urlUuid = match.params.objectId;
        if (response.uuid !== urlUuid) {
            setSensitivity(id, false);
            history.push(match.url.replace(match.params.objectId, response.uuid));
        } else {
            onSave(response);
        }
    };

    const initial = {
        ...point,
        // infrastructure_provider: point.container.infrastructure_provider.id,
    };
    return (
        <>
            <ApiFormWithModel
                // objectType="dataport"
                resourceName="dataport"
                // resourceArguments={[mapUuid]}
                objectId={point.uuid}
                initial={initial}
                excludeFields={['sfp']}
                onSave={handleUpdate}
                onClose={onClose}
                height="100%"
                partialUpdate
            />
        </>
    );
};

export default connect(null, (dispatch) => (bindActionCreators(sidePanelActionCreators, dispatch)))(
    withRouter(DataPortEditor),
);
